import { withStyles } from "@material-ui/core"

import { ResponsiveBar } from "@nivo/bar"
import React, { useEffect, useState } from "react"
import { useMediaQuery } from "react-responsive"
import { getDisplayName } from "../../../util/deviceHelpers"
import { limitString } from "../../../util/tableUtils"
import WidgetCommon from "../Common/widgetCommon"

const styles = () => ({})

const HoursSinceLastGraph = (props) => {
  const {
    isLoading,
    insights,
    devices,
    allowEdits,
    handleWidgetChange,
    widgetId,
    gridStep,
    position,
    size,
    handleRemove,
  } = props
  const [graphData, setGraphData] = useState([])
  const [graphType, setGraphType] = useState("linear")
  const isMobile = useMediaQuery({ query: "(max-width: 625px)" })

  useEffect(() => {
    if (devices && insights) {
      const currentDate = new Date(Date.now() + new Date().getTimezoneOffset() * 60 * 1000)
      const dataMap = {}
      for (const device of devices) {
        if (device.last_seen) {
          dataMap[device.device_id] = {
            device_name: limitString(getDisplayName(device), 13),
            hours_check_in: Math.floor(
              (currentDate - new Date(device.last_seen)) / (1000 * 60 * 60),
            ),
            hours_camera_trigger: device.hours_since_last_camera_trigger,
          }
        }
      }
      for (const insight of insights) {
        if (insight.device_id && insight.device_id in dataMap) {
          const insightTime = new Date(insight.time_stamp)
          if (
            !dataMap[insight.device_id].insight_time ||
            dataMap[insight.device_id].insight_time < insightTime
          ) {
            dataMap[insight.device_id].insight_time = insightTime
            dataMap[insight.device_id].hours_insight = Math.floor(
              (currentDate - insightTime) / (1000 * 60 * 60),
            )
          }
        }
      }
      setGraphData(Object.values(dataMap))
    }
  }, [insights, devices])

  return (
    <WidgetCommon
      widgetId={widgetId}
      title="Hours Since Last Device Communication"
      isLoading={isLoading}
      hasNoData={graphData.length === 0}
      hasTooMuchData={graphData.length >= 20 && isMobile}
      tooMuchDataString="Too many devices. Please filter to fewer devices."
      info="Hours since last insight can change based on the filters applied to the data."
      graphType={graphType}
      setGraphType={setGraphType}
      graphSwitch={true}
      size={size}
      position={position}
      allowResize={true}
      allowEdits={allowEdits}
      handleWidgetChange={handleWidgetChange}
      gridStep={gridStep}
      handleRemove={handleRemove}
    >
      <div style={{ position: "absolute", width: "100%", height: "100%" }}>
        <ResponsiveBar
          data={graphData}
          keys={["hours_insight", "hours_check_in", "hours_camera_trigger"]}
          indexBy="device_name"
          margin={{
            top: isMobile ? 10 : 50,
            right: isMobile ? 10 : 180,
            bottom: 100,
            left: isMobile ? 40 : 80,
          }}
          padding={0.3}
          valueScale={{ type: graphType }}
          indexScale={{ type: "band", round: true }}
          colors={{ scheme: "paired" }}
          groupMode="grouped"
          borderColor={{
            from: "color",
            modifiers: [["darker", 1.6]],
          }}
          axisTop={null}
          axisRight={null}
          axisBottom={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 90,
            legend: !isMobile && "Devices",
            legendPosition: "middle",
            legendOffset: 90,
            truncateTickAt: 0,
          }}
          axisLeft={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: !isMobile && "Hours",
            legendPosition: "middle",
            legendOffset: -55,
            truncateTickAt: 0,
          }}
          labelSkipWidth={12}
          labelSkipHeight={12}
          labelTextColor={{
            from: "color",
            modifiers: [["darker", 1.6]],
          }}
          role="application"
          ariaLabel="Hours since Last"
          legends={
            !isMobile
              ? [
                  {
                    dataFrom: "keys",
                    anchor: "bottom-right",
                    direction: "column",
                    justify: false,
                    translateX: 120,
                    translateY: 0,
                    itemsSpacing: 2,
                    itemWidth: 100,
                    itemHeight: 20,
                    itemDirection: "left-to-right",
                    itemOpacity: 0.85,
                    symbolSize: 20,
                    effects: [
                      {
                        on: "hover",
                        style: {
                          itemOpacity: 1,
                        },
                      },
                    ],
                  },
                ]
              : []
          }
        />
      </div>
    </WidgetCommon>
  )
}

export default withStyles(styles)(HoursSinceLastGraph)
